/**
 * @flow
 * @relayHash 1df70f8a0d7e9c81bb4f81495e361cf5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CustomerInfoForm_viewer$ref = any;
export type CustomerInfoFormRefetchQueryVariables = {||};
export type CustomerInfoFormRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: CustomerInfoForm_viewer$ref
  |}
|};
export type CustomerInfoFormRefetchQuery = {|
  variables: CustomerInfoFormRefetchQueryVariables,
  response: CustomerInfoFormRefetchQueryResponse,
|};
*/


/*
query CustomerInfoFormRefetchQuery {
  viewer {
    ...CustomerInfoForm_viewer
    id
  }
}

fragment CustomerInfoForm_viewer on Viewer {
  user {
    firstName
    lastName
    phoneNumber
    companyName
    officeName
    departmentName
    businessType
    jobCategoryType
    subdivisionCode
    id
  }
  ...FormBusinessTypeField_viewer
  ...FormSubdivisionField_viewer
  ...FormJobCategoryTypeField_viewer
}

fragment FormBusinessTypeField_viewer on Viewer {
  businessTypes {
    id
    plainId
    name
    label
  }
}

fragment FormJobCategoryTypeField_viewer on Viewer {
  jobCategoryTypes {
    id
    plainId
    name
    label
  }
}

fragment FormSubdivisionField_viewer on Viewer {
  subdivisionCodes {
    id
    plainId
    langId
    type
    key
    label
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "plainId",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v3 = [
  (v0/*: any*/),
  (v1/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
  (v2/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CustomerInfoFormRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CustomerInfoForm_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CustomerInfoFormRefetchQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "phoneNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "companyName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "officeName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "departmentName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "businessType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "jobCategoryType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "subdivisionCode",
                "args": null,
                "storageKey": null
              },
              (v0/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "businessTypes",
            "storageKey": null,
            "args": null,
            "concreteType": "BusinessType",
            "plural": true,
            "selections": (v3/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "subdivisionCodes",
            "storageKey": null,
            "args": null,
            "concreteType": "SubdivisionCodeType",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "langId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "type",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "key",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "jobCategoryTypes",
            "storageKey": null,
            "args": null,
            "concreteType": "JobCategoryType",
            "plural": true,
            "selections": (v3/*: any*/)
          },
          (v0/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CustomerInfoFormRefetchQuery",
    "id": null,
    "text": "query CustomerInfoFormRefetchQuery {\n  viewer {\n    ...CustomerInfoForm_viewer\n    id\n  }\n}\n\nfragment CustomerInfoForm_viewer on Viewer {\n  user {\n    firstName\n    lastName\n    phoneNumber\n    companyName\n    officeName\n    departmentName\n    businessType\n    jobCategoryType\n    subdivisionCode\n    id\n  }\n  ...FormBusinessTypeField_viewer\n  ...FormSubdivisionField_viewer\n  ...FormJobCategoryTypeField_viewer\n}\n\nfragment FormBusinessTypeField_viewer on Viewer {\n  businessTypes {\n    id\n    plainId\n    name\n    label\n  }\n}\n\nfragment FormJobCategoryTypeField_viewer on Viewer {\n  jobCategoryTypes {\n    id\n    plainId\n    name\n    label\n  }\n}\n\nfragment FormSubdivisionField_viewer on Viewer {\n  subdivisionCodes {\n    id\n    plainId\n    langId\n    type\n    key\n    label\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c82448265d6a17b893b564fce374074c';
module.exports = node;
